import { useHistory } from 'react-router-dom';

export default function useSearchParams(): [URLSearchParams] {
  const { location } = useHistory();
  return [new URLSearchParams(location.search)];
}
